module.exports = __webpack_public_path__ + "static/img/jchb1-7.48d48a8.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/layout/jchb1-7.png
// module id = 766
// module chunks = 0